import { combineEpics, Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { switchMap, map, startWith, catchError, filter } from 'rxjs/operators';
import { isOfType } from 'typesafe-actions';

import {
  DataTreeTypes,
  DataTreeAction,
  loadingDatabases,
  loadedDatabases,
  loadingDatabasesFailed,
  loadingSchemas,
  loadedSchemas,
  loadingSchemasFailed,
  loadingTables,
  loadedTables,
  loadingTablesFailed,
  loadingColumns,
  loadedColumns,
  loadingColumnsFailed,
  loadingSelectStarData,
  loadingSelectStarDataFiled,
  loadedSelectStarData
} from '../actions/dataTreeActions';
import { IState } from '../reducers';
import { getDatabases, getSchemas, getTables, getColumns, selectStar  } from '../../services/dataTreeApi';


const loadDatabasesEpic: Epic<DataTreeAction, DataTreeAction, IState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(isOfType(DataTreeTypes.LOAD_DATABASES)),
    switchMap(action =>
      from(getDatabases()).pipe(
        map((response: any) => loadedDatabases(response.result)),
        startWith(loadingDatabases()),
        catchError(() => of(loadingDatabasesFailed()))
      )
    )
  );

const loadSchemasEpic: Epic<DataTreeAction, DataTreeAction, IState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(isOfType(DataTreeTypes.LOAD_SCHEMAS)),
    switchMap(action =>
      from(getSchemas(action.payload.databaseId)).pipe(
        map((response: any) => loadedSchemas(response.result)),
        startWith(loadingSchemas()),
        catchError(() => of(loadingSchemasFailed()))
      )
    )
  );

const loadTablesEpic: Epic<DataTreeAction, DataTreeAction, IState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(isOfType(DataTreeTypes.LOAD_TABLES)),
    switchMap(action =>
      from(getTables(action.payload.databaseId, action.payload.schemaName)).pipe(
        map((response: any) => loadedTables(response.result)),
        startWith(loadingTables()),
        catchError(() => of(loadingTablesFailed()))
      )
    )
  );

const loadColumnsEpic: Epic<DataTreeAction, DataTreeAction, IState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(isOfType(DataTreeTypes.LOAD_COLUMNS)),
    switchMap(action =>
      from(getColumns(action.payload.databaseId, action.payload.tableName, action.payload.schemaName)).pipe(
        map((response: any) => loadedColumns(response.result)),
        startWith(loadingColumns()),
        catchError(() => of(loadingColumnsFailed()))
      )
    )
  );


const selectStarEpic: Epic<DataTreeAction, DataTreeAction, IState, any> = (
  action$,
  state$,
  { dispatch },
) =>
  action$.pipe(
    filter(isOfType(DataTreeTypes.LOAD_SELECT_STAR)),
    switchMap(action =>
      from(selectStar(action.payload.database, action.payload.schema, action.payload.table)).pipe(
        map((response: any) => loadedSelectStarData(response.result)),
        startWith(loadingSelectStarData()),
        catchError(() => of(loadingSelectStarDataFiled()))
      ),
    ),
  );

export default combineEpics(
  loadDatabasesEpic,
  loadSchemasEpic,
  loadTablesEpic,
  loadColumnsEpic,
  selectStarEpic
);
